"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCloseToBlackIndex = exports.isCloseToWhiteIndex = exports.isWhiteColor = exports.isWhiteIndex = exports.isLightColor = exports.contrastsAgainstBlackAndWhite = exports.isLightIndex = exports.WCAGMinimumTextContrast = exports.NominalContrasts = void 0;
var chroma_js_1 = __importDefault(require("chroma-js"));
// This is effectively an enum but we can't define enums with numeric names
exports.NominalContrasts = {
    zero: 0,
    '10': 1,
    '13': 2,
    '15': 3,
    '20': 4,
    '30': 5,
    '45': 6,
    '70': 7,
    '100': 8,
    '150': 9,
    max: 10
};
/**
 * WCAG AA text contrast for body text
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/Understanding_WCAG/Perceivable/Color_contrast
 */
exports.WCAGMinimumTextContrast = 4.5;
/**
 * @deprecated This function no longer represents if a block uses light or dark theme.
 * Use `isLightColor(color: Color): boolean` instead.
 */
function isLightIndex(index) {
    return index < exports.NominalContrasts['45'];
}
exports.isLightIndex = isLightIndex;
/**
 * Checks color contrast against black and white.
 * Returns `result: true` if color meets 4.5 for both black and white.
 */
function contrastsAgainstBlackAndWhite(color) {
    var contrastWithBlack = chroma_js_1.default.contrast(color, 'black');
    var contrastWithWhite = chroma_js_1.default.contrast(color, 'white');
    return {
        result: contrastWithBlack > exports.WCAGMinimumTextContrast && contrastWithWhite > exports.WCAGMinimumTextContrast,
        contrastWithBlack: contrastWithBlack,
        contrastWithWhite: contrastWithWhite
    };
}
exports.contrastsAgainstBlackAndWhite = contrastsAgainstBlackAndWhite;
/**
 * By default picks light or dark based on the best contrast against white and black.
 * If both comparisons are above 4.5 it picks the best contrast unless `prefer` is set.
 */
function isLightColor(color, prefer) {
    if (prefer === void 0) { prefer = null; }
    if (color) {
        var _a = contrastsAgainstBlackAndWhite(color), contrastsResult = _a.result, contrastWithBlack = _a.contrastWithBlack, contrastWithWhite = _a.contrastWithWhite;
        if (prefer != null && contrastsResult) {
            return prefer === 'light';
        }
        return contrastWithBlack > contrastWithWhite;
    }
    return false;
}
exports.isLightColor = isLightColor;
/**
 * @deprecated This function no longer represents if a block is white.
 * Use `isWhiteColor(color: Color): boolean` instead
 */
function isWhiteIndex(index) {
    return index === exports.NominalContrasts.zero;
}
exports.isWhiteIndex = isWhiteIndex;
/**
 * Determines if a color can be considered white within a small tolerance
 */
function isWhiteColor(color) {
    if (color) {
        var luminance = (0, chroma_js_1.default)(color).luminance();
        return luminance >= 0.98;
    }
    return false;
}
exports.isWhiteColor = isWhiteColor;
function isCloseToWhiteIndex(index) {
    return index <= exports.NominalContrasts['10'];
}
exports.isCloseToWhiteIndex = isCloseToWhiteIndex;
function isCloseToBlackIndex(index) {
    return index >= exports.NominalContrasts['150'];
}
exports.isCloseToBlackIndex = isCloseToBlackIndex;
//# sourceMappingURL=NominalContrasts.js.map